import BaseApiAction from '@Actions/base-api-action';

export default class UpdateUser extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'users-updateUser',
      payload: { ...this._payload },
    });
  }

  onSuccess(data: any) {
    this._state.admin.users.events.userUpdated.emit();
    super.onSuccess(data);
  }
}
